<template>
  <ReviewsAssetsEdit
    :back-to="{ name: ReviewsRouteName.ReviewsAgencyViewAssets }"
    :documents="agency.documents"
    :documents-fenced="!agency.configFlags.documentsEditable"
    :entity-id="agency.id"
    :global-id="agency.globalId"
    :screenshots="agency.screenshots"
    :screenshots-fenced="!agency.configFlags.screenshotsEditable"
    subject="agency"
    @update="onUpdate"
  >
    <template #tabs>
      <ReviewsAgencyTabs />
    </template>
  </ReviewsAssetsEdit>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { ReviewsAgencyTabs } from '@/components/ReviewsAgenciesManagements'
import ReviewsAssetsEdit from '@/components/ReviewsCommon/ReviewsAssetsEdit/ReviewsAssetsEdit.vue'
import type { AgencyData } from '@/gql/reviews'
import { showNotification } from '@/helpers/notificationHelper.ts'
import { ReviewsRouteName } from '@/router/types.ts'
import { reloadReviewsAgencyKey } from '@/symbols/reviewsReloadKeys'

const props = defineProps<{
  agency: AgencyData
}>()

const { t } = useI18n()
const router = useRouter()
const reloadReviewsAgency = inject(reloadReviewsAgencyKey) as () => void

async function onUpdate() {
  reloadReviewsAgency()
  showNotification(t('Reviews.agency.notifications.savedSuccessfully', { name: props.agency.title }), 'success')
  await router.push({ name: ReviewsRouteName.ReviewsAgencyViewAssets, params: { agencyId: props.agency.id } })
}
</script>
